import React from 'react'
import "./time.scss"
import { useTranslation } from 'react-i18next'
export default function Time() {
  const [t] = useTranslation(["common"])
  return (
    <div className='time'>
          <span className="emoji hourglass" role="img" aria-label="hourglass">
          </span> 
          <h2 className='conclusion'>{t("Conclude")}</h2> 
    </div>
  )
}
